var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('v-container',[_c('h2',[_vm._v("Воронка не найдена")]),_c('p',[_vm._v("Возможно ее удалили, или она никогда не существовала")]),_c('v-btn',{attrs:{"color":"primary","to":{ name: 'boards' }}},[_vm._v("Вернуться к списку воронок")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }